import { useLayoutEffect, type RefObject } from 'react';

export const PAGE_TRANSITION_MS = 1500;

/* Page transition: opacity-only fade (no transform, so the Home hero pin and
   fixed elements are unaffected). Runs before first paint to avoid any flash. */
export default function usePageTransition(
  refs: RefObject<HTMLElement | null>[],
  key: string,
) {
  useLayoutEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const targets = refs.map((r) => r.current).filter(Boolean) as HTMLElement[];
    const anims = targets.map((el) => el.animate(
      [{ opacity: 0 }, { opacity: 1 }],
      { duration: PAGE_TRANSITION_MS, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' },
    ));
    return () => anims.forEach((a) => a.cancel());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}